module.exports = __webpack_public_path__ + "templates/register.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/login/templates/register.html
// module id = M1/7
// module chunks = 1